import { CRUD } from "@/shared/components";
import {
  CollectionTypesListQuery,
  CollectionTypeShowQuery,
  DeleteCollectionTypesMutation,
  RestoreCollectionTypesMutation,
} from "@/admin/entities/collectionTypes";
import { useCollectionTypesManagement, type CollectionTypeRow } from "../model";
import * as CollectionTypesSchemas from "../model/schemas";
import { createEditSchema } from "../model/schemas";
import { CollectionTypeShowComponent } from "@/admin/features/collectionTypes";

/**
 * Админский CRUD типов коллекций (порт референсного
 * RightholderCollectionTypes; per-platform — фильтр по платформе).
 */
export function CollectionTypes() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useCollectionTypesManagement();

  return (
    <CRUD<CollectionTypeRow>
      listQuery={CollectionTypesListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={CollectionTypesSchemas.filterSchema}
      createSchema={CollectionTypesSchemas.createSchema}
      editSchema={createEditSchema(CollectionTypeShowComponent)}
      editQuery={CollectionTypeShowQuery}
      deleteMutation={DeleteCollectionTypesMutation}
      restoreMutation={RestoreCollectionTypesMutation}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
